import * as React from 'react'
import { twMerge } from 'tailwind-merge'
import { LoadingStateSpinner } from './nested/spinner'
import { LoadingStateText } from './nested/text'

interface LoadingStateProps extends React.ComponentProps<'div'> {
  className?: string
  children?: React.ReactNode
}

function LoadingState({ className, children, ...props }: LoadingStateProps) {
  return (
    <div className={twMerge('flex items-center gap-2 text-sm', className)} {...props}>
      {children}
    </div>
  )
}

LoadingState.Spinner = LoadingStateSpinner
LoadingState.Text = LoadingStateText

export { LoadingState }
